<div class="logbook-card">
  <div class="logbook-card__header">
    <h5>{{ 'ProjectsDashboard.summary.logbook.title' | translate }}</h5>
    <div class="logbook-card__actions">
      <button
        type="button"
        class="logbook-card__add-button"
        (click)="openCommentModal()"
        [attr.aria-label]="'ProjectsDashboard.summary.logbook.commentLabel' | translate"
      >
        <svg-icon src="./assets/img/ic-plus-add.svg" />
      </button>

      <svg-icon
        class="logbook-card__open-icon"
        src="/assets/img/ic-external-link.svg"
        (click)="openFullLogbook()"
      />
    </div>
  </div>

  @if (loading()) {
    <div class="logbook-card__state">
      <div class="lds-dual-ring"></div>
    </div>
  } @else if (!rows().length) {
    <div class="logbook-card__state logbook-card__state--empty">
      <div class="logbook-card__empty-state">
        <div class="logbook-card__empty-icon">
          <svg-icon src="/assets/img/ic-list-mini.svg" />
        </div>
        <div class="logbook-card__empty-title">
          {{ 'ProjectsDashboard.summary.logbook.empty' | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="logbook-table">
      <div class="logbook-table__body">
        @for (row of rows(); track row.id) {
          <div
            class="logbook-table__row"
            [class.logbook-table__row--clickable]="row.isNavigable"
            (click)="openRowAction(row)"
          >
            <div class="logbook-table__cell">
              {{ row.created | date: 'dd.MM.yyyy HH:mm' }}
            </div>
            <div class="logbook-table__cell logbook-table__cell--bold">
              <div
                class="logbook-table__actor no-select"
                [class.logbook-table__actor--clickable]="!!row.actorContactId"
                (click)="openActorContact($event, row.actorContactId)"
              >
                <avatar [imageUrl]="row.actorAvatarUrl" [width]="16" [height]="16" [rounded]="true" />
                <span>{{ row.actorName }}</span>
              </div>
            </div>
            <div class="logbook-table__cell">
              {{ row.typeLabel }}
            </div>
            <div class="logbook-table__cell">
              {{ row.description }}
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
